import { Component, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  template: `<ng-content></ng-content>`,
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  /** Deixa a borda levemente mais visível o tempo todo (sem hover) */
  @Input() highlighted = false;

  /** Desabilita o efeito hover */
  @Input() static = false;

  @HostBinding('class.is-highlighted') get isHighlighted() {
    return this.highlighted;
  }

  @HostBinding('class.is-static') get isStatic() {
    return this.static;
  }
}